import { scheduleData } from '../../../utils/constants';
import './ScheduleTable.css';

interface TimeEntry {
  day: string;
  time: string;
  trainer: string;
  studentsCount?: number;
  groupName?: string;
}

const handleCellClick = (
  group: string,
  day: string,
  time: string,
  onCellClick: (group: string, day: string, time: string) => void,
) => {
  onCellClick(group, day, time);
};

const renderCell = (
  timeEntry: TimeEntry,
  cellIndex: number,
  onCellClick: (group: string, day: string, time: string) => void,
) => {
  const hasData = !!timeEntry.time;

  let backgroundColor = 'transparent';

  if (hasData && typeof timeEntry.studentsCount === 'number') {
    const count = timeEntry.studentsCount;

    // нормализация [1, 14] → [0, 1]
    const minCount = 1;
    const maxCount = 14;
    const ratio = Math.min(
      Math.max((count - minCount) / (maxCount - minCount), 0),
      1,
    );

    // hue: 120 (зелёный) → 0 (красный)
    const hue = 120 - ratio * 120;

    backgroundColor = `hsl(${hue}, 70%, 75%)`;
  }
  const cellClass = hasData ? 'cell-clickable cell-link' : '';

  return (
    <td
      key={cellIndex}
      className={cellClass}
      style={{ backgroundColor }}
      title={
        timeEntry.studentsCount
          ? `Учеников: ${timeEntry.studentsCount}`
          : 'Пока никого'
      }
      onClick={() =>
        hasData &&
        handleCellClick(
          timeEntry.groupName ?? '',
          timeEntry.day,
          timeEntry.time,
          onCellClick,
        )
      }
    >
      {hasData && (
        <>
          <div style={{ marginBottom: '10px', textDecoration: 'underline' }}>
            {timeEntry.time}
          </div>
          <div style={{ color: '#444', marginBottom: '10px' }}>
            {timeEntry.trainer}
          </div>
        </>
      )}
    </td>
  );
};

const renderTableRows = (
  onCellClick: (group: string, day: string, time: string) => void,
) => {
  const days = ['ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ', 'ВС'];

  return scheduleData.map((entry, rowIndex) => {
    const cells = days.map((day, cellIndex) => {
      const timeEntry = entry.times.find((t) => t.day === day);
      return timeEntry ? (
        renderCell(timeEntry as TimeEntry, cellIndex, onCellClick)
      ) : (
        <td key={cellIndex}></td>
      );
    });

    return (
      <tr key={rowIndex}>
        <td>{entry.group}</td>
        {cells}
      </tr>
    );
  });
};

const ScheduleTable = ({
  onCellClick,
}: {
  onCellClick: (group: string, day: string, time: string) => void;
}) => (
  <div className="schedule-table__general">
    <h1 className="schedule-table__title">Расписание</h1>
    <p className="schedule-table__text">Учебный год 2025-2026</p>
    <p className="schedule-table__text">
      <span className="schedule-table__text_red">
        Чтобы оставить заявку на запись - кликните на ячейку в таблице
      </span>
    </p>
    <table className="schedule-table__content">
      <thead>
        <tr>
          <th>Группа</th>
          <th>ПН</th>
          <th>ВТ</th>
          <th>СР</th>
          <th>ЧТ</th>
          <th>ПТ</th>
          <th>СБ</th>
          <th>ВС</th>
        </tr>
      </thead>
      <tbody>{renderTableRows(onCellClick)}</tbody>
    </table>
    <p className="schedule-table__legend">
      Цвет ячеек показывает количество учеников: чем ближе к{' '}
      <span style={{ color: 'red' }}>желтому</span>, тем больше детей (но не
      более 7 у одного тренера); чем ближе к
      <span style={{ color: 'green' }}> зелёному</span> — тем меньше. Данные
      актуальны на 27 ноября.
    </p>
  </div>
);

export default ScheduleTable;
